module.exports = __webpack_public_path__ + "img/mobile/Background/fs_background_pt@1.5x.jpg?1.1.2";